import type UAParser from "ua-parser-js";

// Module-level cache
let cachedParser: UAParser.UAParserInstance | null = null;
let parserPromise: Promise<UAParser.UAParserInstance> | null = null;

/**
 * Lazily loads and caches UAParser
 * @returns Promise that resolves to UAParser instance
 */
export const getUAParser = async (): Promise<UAParser.UAParserInstance> => {
  // Return cached parser if available
  if (cachedParser) {
    return cachedParser;
  }

  // Return existing promise if already loading
  if (parserPromise) {
    return parserPromise;
  }

  // Dynamically import and cache
  parserPromise = import("ua-parser-js").then((module) => {
    const UAParserConstructor = module.default;
    cachedParser = new UAParserConstructor();
    return cachedParser;
  });

  return parserPromise;
};
